<template>
  <span :title="string">
    {{ string | shrinkString(length) }}
  </span>
</template>

<script>
export default {
  name: 'ShrinkStringDisplay',
  props: {
    string: {
      type: String,
    },
    length: {
      type: Number,
      default: 50,
    },
  },
}
</script>

<style scoped>

</style>
